import React, { useState, useEffect } from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';

export const setProgress = (percentage, label) => {
    const progress = { percentage, label };
    setTimeout(() => { window.dispatchEvent(new CustomEvent("progressUpdate", { detail: progress })); }, 10);
    return progress;
};

const Progreso = () => {
    const [stateProgress, setStateProgress] = useState(null);

    let state = stateProgress;

    useEffect(() => {
        window.addEventListener("progressUpdate", (e) => { setStateProgress(e.detail) });
    }, []);

    if (!state) state = { percentage: 0, label: "" }
    let variant = state.percentage === 100 ? "primary" : "success";

    return (<>
        {!!state.label && <div style={{ color: "var(--blue)" }}>{state.label}</div>}
        {!!state.percentage && <ProgressBar variant={variant} now={state.percentage} />}
    </>);
};

export default Progreso;